import React from 'react';

import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';

import { PanelAction } from '../../panel-action/panel-action';
import type { PanelActionProps } from '../../panel-action/types';

export interface PanelActionUpProps extends Pick<
	PanelActionProps,
	'onClick' | 'testId' | 'label'
> {}

/**
 * A navigation action for moving up in panels. Place PanelActionUp followed by
 * PanelActionDown before other actions in PanelActionGroup.
 */
export const PanelActionUp: React.ForwardRefExoticComponent<
	PanelActionUpProps & React.RefAttributes<HTMLButtonElement>
> = React.forwardRef<HTMLButtonElement, PanelActionUpProps>(({ onClick, testId, label }, ref) => {
	return (
		<PanelAction
			ref={ref}
			onClick={onClick}
			testId={testId}
			spacing="compact"
			icon={() => <ChevronUpIcon label="" color="currentColor" size="medium" />}
			label={label || 'Go up'}
		/>
	);
});

PanelActionUp.displayName = 'PanelActionUp';
